import React from "react";
import { Row, Col, Space, Button, Avatar, Typography, Grid } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CartActions = ({ cart, handleDeleteCart, handleCheckAllChange }) => {
  const screens = useBreakpoint();

  return (
    <Row
      justify="space-between"
      align="middle"
      gutter={[12, 12]}
      style={{ marginBottom: "12px" }}
    >
      {/* Seller Info */}
      <Col xs={24} sm={12}>
        <Row align="middle" wrap={false}>
          <Col flex="none">
            <Avatar
              src={cart.seller?.photoUrl || "/default-avatar.png"}
              size={screens.xs ? 32 : 40}
              style={{ marginRight: "10px" }}
            />
          </Col>
          <Col flex="auto" style={{ minWidth: 0 }}>
            <Title
              level={5}
              style={{
                margin: 0,
                fontSize: screens.xs ? "15px" : "18px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {cart.seller?.username}
            </Title>
          </Col>
        </Row>
      </Col>

      {/* Action Buttons */}
      <Col
        xs={24}
        sm={12}
        style={{
          textAlign: screens.xs ? "left" : "right",
        }}
      >
        <Space size={screens.xs ? "small" : "middle"}>
          <Button
            type="text"
            icon={<DeleteOutlined />}
            danger
            size={screens.xs ? "small" : "middle"}
            onClick={() => handleDeleteCart(cart._id)}
          >
            Delete Cart
          </Button>
          <Button
            type="primary"
            size={screens.xs ? "small" : "middle"}
            onClick={() => handleCheckAllChange(cart._id, true)}
          >
            Select All
          </Button>
        </Space>
      </Col>
    </Row>
  );
};

export default CartActions;
